module.exports = __webpack_public_path__ + "static/demo-mashup-388f810c1c6a0e292fcc2f47f70bd632.mp4";